module.exports = {
  CommonName: '2.5.4.3',
  CountryName: '2.5.4.6',
  LocalityName: '2.5.4.7',
  StateOrProvinceName: '2.5.4.8',
  StreetAddress: '2.5.4.9',
  OrganizationName: '2.5.4.10',
  OrganizationalUnitName: '2.5.4.11',
  SM2SigningWithSM3: '1.2.156.10197.1.501',
  ECCPubKey: '1.2.840.10045.2.1',
  SM2ECC: '1.2.156.10197.1.301',
  ChallengePassword: '1.2.840.113549.1.9.7',
  Email: '1.2.840.113549.1.9.1',
  SM2KeyExchangeTempPubkey: '1.2.840.113549.1.9.63',
  AuthorityInformationAccess: '1.3.6.1.5.5.7.1.1',
  AuthorityKeyIdentifier: '2.5.29.35', // 授权密钥标识符
  SubjectKeyIdentifier: '2.5.29.14', // 主题密钥标识符
  keyUsage: '2.5.29.15', // 密钥使用用途
  CRLDistributionPoints: '2.5.29.31', // CRL Distribution Points
  BasicConstraints: '2.5.29.19', // 基本约束，标识是否CA颁发
  ExtKeyUsage: '2.5.29.37', // Extended key usage
};
